<panel width="650">
	<menu always-visible>
		<menuitem *requiredCredential="credentialTypeEnum.EditMicrosoft365; and: loadedTenantInfo && (microsoftSubscriptions == undefined || microsoftSubscriptions.length == 0) && !changeTenantMode" (click)="changeTenantMode = true">{{ 'company.microsoft365.context-menu.change-tenant' | translate }}</menuitem>
	</menu>
	<h1>{{ 'company.microsoft365' | translate }}</h1>

	@if (!loadedTenantInfo) {
		<skeletons [defaultSkeletons]="3" />
	}
	@else if (!microsoftTenant) {
		<section><strong>{{ 'microsoft365.no-tenant' | translate }}</strong></section>
	}
	@else if (customerTenant && microsoftTenant) {
		<section>
			<text-group>
				<strong>{{ 'general.tenantName' | translate }}:</strong>{{ customerTenant.name }}
				<strong>{{ 'general.id' | translate }}:</strong> {{ microsoftTenant.tenantId }}
				<strong>{{ 'microsoft365.microsoft-tenant-id' | translate }}:</strong> {{ microsoftTenant.msCustomerTenantId }}
				<strong>{{ 'microsoft365.tenant-contact-mail' | translate }}:</strong> {{ customerTenant.contactMail }}
				<strong>{{ 'microsoft365.admin-portal' | translate }}:</strong>
				<div>
					<button small href="https://admin.microsoft.com/Partner/BeginClientSession.aspx?CTID={{ microsoftTenant.msCustomerTenantId }}&CSDEST=o365admincenter">
						<icon type="external-link" />{{ 'microsoft365.go-to-admin-portal' | translate }}
					</button>
				</div>
			</text-group>
		</section>
		@if (!changeTenantMode && !loadedSubscriptions) {
			<skeletons [defaultSkeletons]="2" />
		}
		@if (!changeTenantMode && loadedSubscriptions) {
			@if (availableSubscriptions.length > 0) {
				<h3>{{ 'microsoft365.crayon-subscriptions-without-product-plan' | translate }}</h3>
				<list-view scrollable [selectable]="false" [emptyLabel]="'microsoft365.product-list-empty-label'">
					<header>{{ 'microsoft365.column.crayon-subscription-name' | translate }}</header>
					<header>{{ 'microsoft365.column.crayon-quantity' | translate }}</header>
					<header>{{ 'microsoft365.column.crayon-status' | translate }}</header>
					<row *listData="let subscription from availableSubscriptions" [highlighted]="selectedSubscription?.id == subscription.id" (action)="selectCrayonSubscription(subscription)">
						<column>{{ subscription.name }}</column>
						<column>{{ subscription.quantity }}</column>
						<column>{{ ('enum.crayon-subscription-status.' + crayonSubscriptionStatusEnum[subscription.status]) | translate }}</column>
					</row>
				</list-view>
			}
			@if (activeProductPlanSubscriptions.length > 0) {
				<h3>{{ 'microsoft365.product-plans-subscriptions.active' | translate }}</h3>
				<list-view scrollable [selectable]="false">
					<header>{{ 'microsoft365.column.reference-no' | translate }}</header>
					<header>{{ 'microsoft365.column.crayon-subscription-name' | translate }}</header>
					<header>{{ 'microsoft365.column.status' | translate }}</header>
					<row *listData="let pps from activeProductPlanSubscriptions" [highlighted]="selectedProductPlanSubscription == pps" (action)="selectProductPlanSubscription(pps);">
						<column>{{ getActiveAccountingPlanReferenceNoFromProductPlan(pps.productPlan) }}</column>
						<column>{{ pps.crayonSubscription?.name }}</column>
						<column>{{ pps.status | translate }}</column>
					</row>
				</list-view>
			}
			@if (upcomingProductPlanSubscriptions.length > 0) {
				<h3>{{ 'microsoft365.product-plans-subscriptions.upcoming' | translate }}</h3>
				<list-view>
					<header>{{ 'microsoft365.column.reference-no' | translate }}</header>
					<header>{{ 'microsoft365.column.product-name' | translate }}</header>
					<header>{{ 'microsoft365.column.status' | translate }}</header>
					<row *listData="let pps from upcomingProductPlanSubscriptions" [highlighted]="selectedProductPlanSubscription == pps" (action)="selectProductPlanSubscription(pps);">
						<column>{{ getActiveAccountingPlanReferenceNoFromProductPlan(pps.productPlan) }}</column>
						<column>{{ pps.productPlan | productName }}</column>
						<column>{{ pps.status | translate }}</column>
					</row>
				</list-view>
			}
		}
		<section *requiredCredential="credentialTypeEnum.CreateFreeMicrosoft365; and: freeMS365Eligible">
			<button #createFreeMs365Button (click)="selectParentAndCreateFreeMicrosoft365()">{{ 'microsoft365.create-free-ms365.button-text' | translate }}</button>
		</section>
	}

	@if (loadedTenantInfo && (!customerTenant || changeTenantMode)) {
		@if (customerTenant) {
			<h2>{{ 'microsoft365.change-tenant' | translate }}</h2>
		}
		@if (!editPermission) {
			<section>{{ 'microsoft365.missing-permission' | translate }}</section>
		}
		@else {

			<section><custom-input [label]="'microsoft365.search-tenant' | translate" [(value)]="searchString" (valueChange)="searchTenants()" /></section>

			@if (searchingTenants) {
				<skeletons [defaultSkeletons]="3" />
			}
			@else if (tenantList) {
				<h3>{{ 'microsoft365.found-tenants' | translate }}</h3>
				<list-view scrollable>
					<header>{{ 'microsoft365.column.tenant-name' | translate }}</header>
					<row *listData="let tenant from tenantList" [highlighted]="selectedTenant == tenant" (action)="selectedTenant = tenant">
						<column>{{ tenant.name }}</column>
					</row>
				</list-view>
				<section>
					<button #assignTenantToCompanyButton confirm [active]="selectedTenant != undefined" (click)="assignSelectedTenantToCompany()">{{ 'microsoft365.assign-tenant' | translate }}</button>
				</section>
			}
			<section>{{ 'general.or' | translate }}</section>
			<section>
				<button #createTenantButton confirm (click)="createTenant()">{{ 'microsoft365.create-tenant' | translate }}</button>
			</section>
			@if (changeTenantMode) {
				<section>
					<button ghost (click)="cancelChangeTenant()">{{ 'general.cancel' | translate }}</button>
				</section>
			}
		}
	}
</panel>

@if (customerTenant && selectedProductPlanSubscription && !selectedProductPlanSubscription.productPlan.deliveryDate) {
	<company-microsoft365-edit *requiredCredential="credentialTypeEnum.EditMicrosoft365" [customerTenantId]="customerTenant.id" [crayonProducts]="crayonProducts" [productPlanSubscription]="selectedProductPlanSubscription"></company-microsoft365-edit>
}

@if (selectedSubscription || loadingSubscription) {
	<panel width="600">
		<h1>{{ 'microsoft365.subscription-details.header' | translate }}</h1>
		<section>
			@if (selectedProductPlanSubscription) {
				<h2>{{ 'microsoft365.attached-product-plan' | translate }}</h2>
				<text-group>
					<strong>{{ 'microsoft365.product-plan.name' | translate }}</strong>
					<a (click)="navigateToProductPlan()">{{ selectedProductPlanSubscription.productPlan | productName }}</a>

					<strong>{{ 'microsoft365.product-plan.reference-no' | translate }}</strong>
					<a (click)="navigateToProductPlan()">{{ getActiveAccountingPlanReferenceNoFromProductPlan(selectedProductPlanSubscription.productPlan!) }}</a>
				</text-group>
			}
			@if (loadingSubscription) {
				<h2><skeleton /></h2>
				<skeletons [defaultSkeletons]="7" />
			}
			@else {
				<h2>{{ selectedSubscription?.name }}</h2>
				<text-group>
					<strong>{{ 'microsoft365.subscription-details.product-name' | translate }}</strong>
					<span>{{ selectedSubscription?.productName }}</span>

					<strong>{{ 'microsoft365.subscription-details.subscription-id' | translate }}</strong>
					<span>{{ selectedSubscription?.subscriptionId }}</span>

					<strong>{{ 'microsoft365.subscription-details.billing-cycle' | translate }}</strong>
					<span>{{ ('microsoft365.subscription-details.billing-cycle.' + selectedSubscription?.billingCycle) | translate }}</span>

					<strong>{{ 'microsoft365.subscription-details.term-duration' | translate }}</strong>
					<span>{{ selectedSubscription?.termDuration }}</span>

					<strong>{{ 'microsoft365.subscription-details.end-date' | translate }}</strong>
					<span>{{ selectedSubscription?.endDate | customDate: 'shortDate' }}</span>

					<strong>{{ 'microsoft365.subscription-details.auto-renewal-date' | translate }}</strong>
					<span>{{ selectedSubscription?.autoRenewEnabled ? (dateService.addDays(selectedSubscription?.endDate, 1) | customDate: 'shortDate') : ('general.na' | translate) }}</span>

					<strong>{{ 'microsoft365.subscription-details.quantity' | translate }}</strong>
					<span>{{ selectedSubscription?.quantity }}</span>

					<strong>{{ 'microsoft365.subscription-details.status' | translate }}</strong>
					<span>{{ ('enum.crayon-subscription-status.' + crayonSubscriptionStatusEnum[selectedSubscription?.status ?? 0]) | translate }}</span>
				</text-group>
			}
		</section>
		@if (!selectedProductPlanSubscription && !loadingSubscription && editPermission && (attachToExistingPlanPermission || attachToNewPlanPermission)) {
		<section>
			@if (attachToExistingPlanPermission) {
				<button #attachToExistingProductPlanButton [loader]="false" [active]="selectedSubscription?.status == 1" (click)="attachSubscriptionToExistingProductPlan()"><icon type="link-horizontal" />{{ 'microsoft365.attach-to-existing-product-plan' | translate }}</button>
			}
			@if (attachToNewPlanPermission) {
				<button #createProductPlanAndFreeMs365Button [loader]="false" [active]="selectedSubscription?.status == 1" (click)="assignSubscriptionToNewFreeMicrosoft365ProductPlan()"><icon type="plus" />{{ 'microsoft365.subscription-details.create-product-plan' | translate }}</button>
			}
		</section>
		}
	</panel>
}
